import { createSlice } from '@reduxjs/toolkit';
const initialEditMacroDialog = {
    title: '',
    active: true,
    items: [],
};
export const slice = createSlice({
    name: 'edit_macro_dialog',
    initialState: initialEditMacroDialog,
    reducers: {
        setupEditMacroDialog(state, action) {
            if (action.payload.id !== undefined)
                state.id = action.payload.id;
            state.title = action.payload.title;
            state.active = action.payload.active;
            state.items = action.payload.items;
        },
        setMacroDialogActive(state, action) {
            state.active = action.payload;
        },
        setMacroDialogTitle(state, action) {
            state.title = action.payload;
        },
        editMacroDialogAddItem: {
            reducer: (state, action) => {
                state.items.push({
                    operation: action.payload.operation,
                    transmitter_id: action.payload.device_id,
                    device_id: action.payload.device_id,
                });
            },
            prepare: (device_id, operation) => {
                return { payload: { device_id, operation } };
            }
        },
        editMacroDialogDeleteItem: (state, action) => {
            state.items.splice(action.payload, 1);
        },
        editMacroDialogItemTransmitterChange: {
            reducer: (state, action) => {
                state.items[action.payload.index].transmitter_id = action.payload.transmitter_id;
                state.items[action.payload.index].operation = action.payload.operation;
            },
            prepare: (index, transmitter_id, operation) => {
                return { payload: { index, transmitter_id, operation } };
            }
        },
        editMacroDialogItemChange: {
            reducer: (state, action) => {
                state.items[action.payload.index].operation = action.payload.itemprops.operation;
            },
            prepare: (index, itemprops) => {
                return { payload: { index, itemprops } };
            }
        }
    }
});
export const { setupEditMacroDialog, setMacroDialogActive, setMacroDialogTitle, editMacroDialogAddItem, editMacroDialogDeleteItem, editMacroDialogItemTransmitterChange, editMacroDialogItemChange, } = slice.actions;
export default slice.reducer;
